import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getHistorySelector, getSituationSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { CcHpiConstants } from '../store/ccHpi.constants'
import { IHistoryState, ISituationState } from '../store/ccHpi.types'
import { INarrativeState } from '../../narrative/store/narrative.types'
import { getNarrativeSelector } from '../../narrative/selectors'
import { NarrativeConstants } from '../../narrative/store/narrative.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveCcHpi() {
  const situation: ISituationState = yield select(getSituationSelector)
  const history: IHistoryState = yield select(getHistorySelector)
  const narrative: INarrativeState = yield select(getNarrativeSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const otherComplaintsWithData = situation.otherComplaints?.filter((oc) => oc.ocDuration || oc.otherComplaint)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      patient: { ...pcrDoc.patient, narrative },
      situation: { ...situation, otherComplaints: otherComplaintsWithData },
      history,
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveCcHpi() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveCcHpiSaga() {
  yield takeLatest(
    [
      CcHpiConstants.SAVE_CC_HPI,
      CcHpiConstants.SET_CHIEF_COMPLAINT,
      CcHpiConstants.SET_ALS_ASSESSMENT,
      CcHpiConstants.SET_ALS_ASSESSMENT_RATIONALE,
      CcHpiConstants.SET_PATIENT_ACTIVITY,
      CcHpiConstants.SET_REASON_FOR_ENCOUNTER,
      CcHpiConstants.SET_DRUGS_AND_ALCOHOL,
      CcHpiConstants.SET_DRUGS_AND_ALCOHOL_INDICATORS,
      CcHpiConstants.SET_DRUGS_AND_ALCOHOL_INDICATORS_PNNV,
      CcHpiConstants.SET_CCDURATION,
      CcHpiConstants.SET_CCDURATION_UNIT,
      CcHpiConstants.SET_SECONDARY_COMPLAINT,
      CcHpiConstants.SET_SCDURATION,
      CcHpiConstants.SET_SCDURATION_UNIT,
      CcHpiConstants.SET_OTHER_COMPLAINTS,
      NarrativeConstants.SET_HPI,
    ],
    performWithMutexHOG,
    saveCcHpi
  )
}
